import { Resource } from "react-admin";
import EcobalyseList from "./ecobalyse/EcobalyseList";
import EcobalyseShow from "./ecobalyse/EcobalyseShow";

const ecobalyseResource = () => (
  <Resource
    name="ecobalyse"
    options={{ label: "Ecobalyse", menuGroup: "Accounts" }}
    list={EcobalyseList}
    show={EcobalyseShow}
  />
);

export default ecobalyseResource;
